import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ABOUT_IMG = 'http://geel.fp.08wx.cn/images/9b4786933662b982ce0ec3ffd06c5a2e.jpg';

const highlights = [
  { icon: 'ri-global-line', text: '新加坡总部，全球服务' },
  { icon: 'ri-team-line', text: '区块链专家、工程师、Web3 顾问组成的核心团队' },
  { icon: 'ri-lightbulb-line', text: '技术即服务，推动实体经济与 Web3 深度融合' },
  { icon: 'ri-git-branch-line', text: '全生命周期：咨询 → 开发 → 运维' },
];

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="absolute right-0 top-0 w-1/2 h-full bg-gradient-to-l from-primary/5 to-transparent pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-20 items-center">
          {/* Left: Text */}
          <div>
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-information-line text-primary text-sm" />
              <span className="text-primary text-xs font-medium uppercase tracking-wider">{t('about.tag')}</span>
            </div>

            <h2 className="text-4xl xl:text-5xl font-heading font-bold text-gray-900 mb-6 leading-tight">
              {t('about.title')}
            </h2>

            <div className="space-y-4 mb-8">
              <p className="text-gray-500 text-base leading-relaxed">{t('about.desc1')}</p>
              <p className="text-gray-500 text-base leading-relaxed">{t('about.desc2')}</p>
              <p className="text-gray-500 text-base leading-relaxed">{t('about.desc3')}</p>
            </div>

            {/* Highlights */}
            <div className="space-y-3 mb-8">
              {highlights.map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary/10 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-primary text-sm`} />
                  </div>
                  <span className="text-gray-600 text-sm">{item.text}</span>
                </div>
              ))}
            </div>

            {/* Badges */}
            <div className="flex flex-wrap gap-3 mb-8">
              {[t('about.badge'), t('about.badge2'), 'ISO 认证', 'MAS 合规'].map((badge, i) => (
                <span key={i} className="px-4 py-1.5 bg-primary-50 border border-primary-200 text-gray-600 text-xs rounded-full">
                  {badge}
                </span>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary hover:bg-primary-dark text-white font-semibold text-sm rounded-full transition-all duration-200 cursor-pointer"
            >
              {t('about.more')}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border border-primary-200">
              <div className="w-full h-[420px]">
                <img
                  src={ABOUT_IMG}
                  alt="Singapore headquarters"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white/30 via-transparent to-transparent" />
              </div>

              {/* Floating Badge */}
              <div className="absolute top-5 right-5 bg-white/90 border border-primary-200 rounded-xl px-4 py-3 backdrop-blur-sm">
                <div className="text-primary text-xl font-bold font-heading">8+</div>
                <div className="text-gray-500 text-xs">年行业经验</div>
              </div>

              <div className="absolute bottom-5 left-5 bg-white/90 border border-primary-200 rounded-xl px-4 py-3 backdrop-blur-sm">
                <div className="text-gray-800 text-sm font-medium mb-1">总部 · 新加坡</div>
                <div className="flex items-center gap-1">
                  <span className="w-2 h-2 bg-primary rounded-full animate-glow-pulse" />
                  <span className="text-gray-500 text-xs">全球运营中</span>
                </div>
              </div>
            </div>

            {/* Decorative corner */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-r-2 border-b-2 border-primary/20 rounded-br-2xl" />
            <div className="absolute -top-4 -left-4 w-24 h-24 border-l-2 border-t-2 border-accent/20 rounded-tl-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
